import { SectionLabel } from './section-label';

/* "Comment ça marche" steps, extracted from Landing.tsx (decomposition, Phase 4). */
export function HowItWorks() {
  const steps = [
    { n: '01', title: 'Installez Naïa', desc: "Ouvrez l'application web en un clic. Aucun abonnement requis pour démarrer." },
    { n: '02', title: 'Créez le profil', desc: 'Quelques minutes pour configurer le niveau scolaire, les matières et les objectifs. Naïa mémorise tout.' },
    { n: '03', title: "Naïa s'adapte", desc: "L'IA ajuste son rythme et son style au profil unique de chaque élève. Chaque conversation est singulière." },
  ];
  return (
    <section className="section-tinted">
      <div className="landing-container">
        <div data-animate="">
          <SectionLabel>Comment ça marche</SectionLabel>
          <h2 className="section-title">Prêt en 3 minutes.</h2>
        </div>
        <div className="steps-grid">
          {steps.map((s, i) => (
            <div key={s.n} className="step-card" data-animate="" data-delay={String(i * 120)}>
              <div className="step-number">{s.n}</div>
              <h3 className="step-title">{s.title}</h3>
              <p className="step-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
